module.exports = __webpack_public_path__ + "static/media/green_icon.c8ae866b.svg";